import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@material-ui/lab/Skeleton';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

const ContentLoader = ({ type }) => {
  return (
    <>
      {type === 'PARAGRAPH' &&
        <>
          <Skeleton width={280} />
          <Skeleton width={200} />
          <Skeleton width={280} />
          <Skeleton width={160} />
        </>
      }
      {type === 'PAGE' &&
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
        >
          <Box m={32}>
            <CircularProgress />
          </Box>
        </Grid>
      }
    </>
  );
};

ContentLoader.propTypes = {
  type: PropTypes.oneOf([
    'PARAGRAPH',
    'PAGE',
  ]).isRequired,
};

export default ContentLoader;
